
import TableList from "@components/templates/tablelist";
import { HttpGetHeadLogisticsAdmin, HttpAddressList,  HttpGetAllProduct, HttpGetAllOrg, HttpWarehouse } from "@/service/headlogistics";
// import { HttpSysOrgList } from '@mods/service/dictionary';
import { mapState, mapGetters } from "vuex";
import comIndex from './../update/index'
import compSeelogistics from './../newSeelogistics'
import comIncharge from './../setInCharge'
import mixinlist from './../mixin'
export default {
    mixins: [TableList, mixinlist],
    components: {
        comIndex,
        compSeelogistics,
        comIncharge
    },
    watch: {
        loading: {
            handler (val) {
                if (!val) {
                    if (this.loading2) {
                        this.loading = true
                    }
                }
            }
        },
        loading2: {
            handler (val) {
                if (!val) {
                    this.loading = false
                }
            }
        }
    },
    data() {
        return {
            loading2: true,
            // totals: 0,
            contextList: [],
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            addressCodeList: [],
            getAllProduct: [],
        };
    },
    created () {
        this.loading = true
        HttpGetAllProduct().then(res => {
            this.getAllProduct = res.data.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            })
        })
        HttpWarehouse().then(res => {
            this.warehouseList = res.data.map(item => {
                return {
                    value: item.code,
                    label: item.code
                }
            })
        })
        HttpAddressList({
            // 'search[EQ_warehouseType]':2,
            rows: 1000,
        }).then(res=>{
            this.addressCodeList = res.data.content.map(item => {
                return {
                    label: item.code,
                    value: item.code
                }
            })
        },err=>{
            this.$Message.error(err.message);
        })
        HttpGetAllOrg({
            page: 1,
            rows: 1000
            // 'search[EQ_serviceType]': 1
        }).then(res => {
            this.contextList = res.data.content.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            })
            this.loading2 = false
        }, err => {
            this.$VMessage.error(err.message)
        })
    },
    methods: {
        ajaxRequest: HttpGetHeadLogisticsAdmin,
        interceptRequest(params) {
            // 全部
            params.navtabType = 0
            if (params.search.quanbu === 0) {
                params.navtabType = 0

                delete params.search.quanbu
                delete params.search.daishenhe
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.yichang
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待审核
            if (params.search.daishenhe === 0) {
                params.navtabType = 1
                // params.search.IN_orderStatus = 1
                // params.search.IN_logisticsStatus = 0
                let target = [1]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = 0
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daishenhe
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待订舱
            if (params.search.daidingcang === 0) {
                params.navtabType = 2
                // params.search.IN_orderStatus = [6,3]
                // params.search.IN_logisticsStatus = [1,0]
                let target = [3, 6]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = [1,0]
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待发船
            else if (params.search.daifachuan === 0) {
                params.navtabType = 3
                // params.search.IN_orderStatus = 6
                // params.search.IN_logisticsStatus = [2,3]
                let target = [14, 19]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = [2,3]
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 已发船
            else if (params.search.yifachuan === 0) {
                params.navtabType = 4
                // params.search.IN_orderStatus = 7
                // params.search.IN_logisticsStatus = 4
                let target = [7]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待清关
            else if (params.search.daiqingguan === 0) {
                params.navtabType = 5
                // params.search.IN_orderStatus = 7
                // params.search.IN_logisticsStatus = 4
                let target = [7]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待预约
            else if (params.search.daiyuyue === 0) {
                params.navtabType = 6
                // params.search.IN_orderStatus = 7
                // params.search.IN_logisticsStatus = [5,6,7,8]
                // let target = [8, 15, 20]
                // params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // if (params.search.IN_orderStatus.length === 0) {
                //     params.search.IN_orderStatus =  target
                // }
                let target = [8, 15, 20]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待妥投
            else if (params.search.daituotou === 0) {
                params.navtabType = 7
                // params.search.IN_orderStatus = 7
                // params.search.IN_logisticsStatus = 9
                let target = [16, 18]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 已妥投
            else if (params.search.yidaituotou === 0) {
                params.navtabType = 8
                // params.search.IN_orderStatus = [8,11]
                // params.search.IN_logisticsStatus = 10
                let target = [17]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 查验中
            // else if (params.search.jianyanzhong === 0) {
            //     params.navtabType = 8
            //     params.search.NE_orderStatus = 5
            //     params.search.IN_logisticsStatus = 11

            //     delete params.search.daidingcang
            //     delete params.search.daifachuan
            //     delete params.search.daiqingguan
            //     delete params.search.daiyuyue
            //     delete params.search.daituotou
            //     delete params.search.daiscfp
            //     delete params.search.yifachuan
            //     delete params.search.quanbu
            //     delete params.search.yichang
            //     delete params.search.daishenhe
            //     delete params.search.yidaituotou
            //     delete params.search.jianyanzhong
            //     // return params
            // }
            // 待上传发票
            else if (params.search.daiscfp === 0) {
                params.navtabType = 8
                // params.search.IN_orderStatus = 8
                // params.search.IN_logisticsStatus = 10
                let target = [17]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                params.search.EQ_invoiceStatus = 10
                params.search.EQ_carrierType = 0

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 异常
            else if (params.search.yichang === 0) {
                params.navtabType = 9
                params.search.IN_exceptionStatus = [1, 2, 3]

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }

            return params
        },
        toolsRender() {
            return <div>
                {this.getCurrentTabNote}
            </div>
        },
        // interceptResponse(data){
        //     this.totals = data.totalElements;
        // },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                // case "add":
                //     this.$router.push({
                //         name: 'createheadlogistics',
                //         params: { type: "add", jump: 'logistics' },
                //         // query: { id: params },
                //     });
                //     break;
                // case "edit":
                //     this.$router.push({
                //         name: 'headlogiticsUpdate',
                //         params: { type: "edit" },
                //         query: { id: params },
                //     });
                //     break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "headlogiticsUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                // case "submitbox":
                //     this.operate = {
                //         show: true,
                //         alert: "error",
                //         title: "提交",
                //         width: 460,
                //         params: { orderId: params },
                //         formdata: [
                //             {
                //                 tag: "vTextarea",
                //                 key: "remark",
                //                 span: 24,
                //                 label: "备注",
                //                 required: false,
                //             }
                //         ],
                //         ajaxRequest: HttpSubmitLogisticsOne
                //     };
                //     break;
                // case "cancel":
                //     this.operate = {
                //         show: true,
                //         alert: "error",
                //         title: "取消",
                //         width: 460,
                //         params: { orderId: params },
                //         formdata: [
                //             {
                //                 tag: "vTextarea",
                //                 key: "reason",
                //                 span: 24,
                //                 label: "备注",
                //             }
                //         ],
                //         ajaxRequest: HttpCancelLogisticsOne
                //     };
                //     break;
                case "seelogistics":
                    this.operate = {
                        title: this.$t('fbb.inbound.view_logistics', { defaultValue: '物流查看' }),
                        show: true,
                        width: 1200,
                        component: "compSeelogistics",
                        orderid: params,
                        querytype: 'query',
                        boxtype: 'headlogistics',
                        showFooter: false
                    }
                    break;

                case 'export':
                let searchData = {}
                Object.keys(this.formData.search).map(item => {
                    if (/[A-Z]{2}_.*/.test(item)) {
                        searchData[`search[${item}]`] = this.formData.search[item]
                    }
                })
                this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/LogisticsHead/exportByForwarder",
                searchData
                , {
                    executor: 'request',
                    download: true,
                }).catch(err => {
                    this.$VMessage.error(err.message);
                })
                break
                // case 'inCharge':
                //     this.operate = {
                //         title: '指定负责人',
                //         show: true,
                //         component: "comIncharge",
                //         id: params,
                //         showFooter: false
                //     }
                // break
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus } = row
            return [
                // {
                //     label: '提交',
                //     show: orderStatus == 0 || orderStatus == 2,
                //     params: id,
                //     operate: 'submitbox'
                // },
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                // {
                //     label: '编辑',
                //     show: (orderStatus == 10 || orderStatus == 0 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.create'),
                //     params: id,
                //     operate: 'edit'
                // },
                // {
                //     label: '取消',
                //     show: orderStatus == 10 || orderStatus == 0 || orderStatus == 1 || orderStatus == 2,
                //     params: id,
                //     operate: 'cancel'
                // },
                {
                    label: this.$t('fbb.inbound.view_logistics', { defaultValue: '物流查看' }),
                    show: true,
                    params: id,
                    operate: 'seelogistics'
                },]
        },
        getOrderStatus(typeid) {
            let json = this.orderStatusList.filter(item => {
                return item.value == typeid
            })

            return <span class={json[0].color}>{json[0].label}</span>
        },
        getLogisticsStatus(logid) {
            let logjson = this.logisticsStatusList.filter(item => {
                return item.value == logid
            })
            return <span class={logjson[0].color}>{logjson[0].label}</span>
        },
        getExceptionStatus(exceptid) {
            let excepjson = this.exceptionStatus.filter(item => {
                return item.value == exceptid
            })
            if (excepjson[0].label === this.$t('fbb.headlogistics.no_exceptioin', { defaultValue: '无异常' })) {
                return
            }
            return <span class={excepjson[0].color}>{excepjson[0].label}</span>
        },
        getTicketStatus (type) {
            let statusItem = this.ticketStatus.filter(item => {
                return item.value === type
            })[0]
            return <span class={statusItem.color}>{statusItem.label}</span>
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse', 'getAllWareHouseList', 'getProductList']),
        getCurrentTabNote() {
            let noteMap = {
                'quanbu':'',
                'daishenhe':'单据状态-待审核，物流状态-初始化',
                'daidingcang':'单据状态-已确认订舱，物流状态-待订舱',
                'daifachuan':'单据状态-已确认订舱，物流状态-已报关',
                'daiqingguan':'单据状态-发运中，物流状态-已发船',
                'daiyuyue':'单据状态-发运中，物流状态-已到港',
                'daituotou':'单据状态-发运中，物流状态-已预约',
                'daiscfp':'单据状态-已达到，物流状态-已妥投',
                'yifachuan':'单据状态-已确认订舱，物流状态-待订舱',
                'yichang':'',
                'yidaituotou':'',
                'jianyanzhong':'',
            }
            let noteStr = '';
            if (this.formData.search['daishenhe'] === 0) {
                noteStr = noteMap['daishenhe']
            }
            if (this.formData.search['daidingcang'] === 0) {
                noteStr = noteMap['daidingcang']
            }
            if (this.formData.search['daifachuan'] === 0) {
                noteStr = noteMap['daifachuan']
            }
            if (this.formData.search['daiqingguan'] === 0) {
                noteStr = noteMap['daiqingguan']
            }
            if (this.formData.search['daiyuyue'] === 0) {
                noteStr = noteMap['daiyuyue']
            }
            if (this.formData.search['daituotou'] === 0) {
                noteStr = noteMap['daituotou']
            }
            if (this.formData.search['daiscfp'] === 0) {
                noteStr = noteMap['daiscfp']
            }
            if (this.formData.search['yifachuan'] === 0) {
                noteStr = noteMap['yifachuan']
            }
            return noteStr
        },
        // choseOrderStatusList() {
        //     return this.queryOrderStatusList.filter(item => {
        //         return item.value != 10
        //     })
        // },
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0
                },
                // {
                //     name: "待审核",
                //     key: 'daishenhe',
                //     val: 0,
                // },
                {
                    name: this.$t('fbb.headlogistics.daidingcang', { defaultValue: '待订舱' }),
                    key: 'daidingcang',
                    val: 0,
                },
                {
                    name: this.$t('fbb.headlogistics.daifachuan', { defaultValue: "待发船" }),
                    key: 'daifachuan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yifachuan', { defaultValue: "已发船" }),
                    key: 'yifachuan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daiqingguan', { defaultValue: "待清关" }),
                    key: 'daiqingguan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daiyuyue', { defaultValue: "待预约" }),
                    key: 'daiyuyue',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daituotou', { defaultValue: "待妥投" }),
                    key: 'daituotou',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yituotou', { defaultValue: "已妥投" }),
                    key: 'yidaituotou',
                    val: 0
                },
                // {
                //     name: "查验中",
                //     key: 'jianyanzhong',
                //     val: 0
                // },
                {
                    name: this.$t('fbb.headlogistics.daishangchuanfapiao', { defaultValue: "待上传发票" }),
                    key: 'daiscfp',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yichang', { defaultValue: "异常" }),
                    key: 'yichang',
                    val: 0,
                },
            ]
        },
        ToolsData() {
            return [
                // {
                //     name: "添加",
                //     operate: "add",
                //     theme: "primary",
                //     show: this.handleAuth('fbb.logisticsHead.create')
                // },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    theme: 'primary'
                },
                // {
                //     name: '指定负责人',
                //     operate: 'inCharge',
                //     batch: true
                // }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: this.$t('fbb.headlogistics.prelogistics_number', { defaultValue: "头程单号" }),
                    tag: 'vInput',
                    key: 'EQ_preLogisticsNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.logistics_type', { defaultValue: "发运类型" }),
                    tag: 'Select',
                    key: 'EQ_logisticsType',
                    options: [
                        { value: 'transfer', label: this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' }) },
                        { value: 'through', label: this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直达' }) }
                    ],
                    props: {
                        filterable: true,
                    },
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.sublogistics_number', { defaultValue: "关联计划单号" }),
                    tag: 'vInput',
                    key: 'CN_subLogisticsNos',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: "来源单号" }),
                    tag: 'vInput',
                    key: 'EQ_associatedNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.order_status', { defaultValue: "单据状态" }),
                    tag: 'Select',
                    key: 'IN_orderStatus',
                    options: this.queryOrderStatusList,
                    props: {
                        multiple: true,
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.carrier_type', { defaultValue: "货代类型" }),
                    tag: 'Select',
                    key: 'EQ_carrierType',
                    options: [
                        { value: 0, label: this.$t('fbb.headlogistics.carrier_type_standard', {  defaultValue: '标准' }) },
                        { value: 1, label: this.$t('fbb.headlogistics.carrier_type_other', {  defaultValue: '其他' }) },
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: '客户组织' }),
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.contextList,
                    props: {
                        filterable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'Select',
                    options: this.getAllProduct,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.transport_type', { defaultValue: "发运方式" }),
                    tag: 'Select',
                    key: 'IN_transportType',
                    options: this.transportList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.estimate_sail_at', { defaultValue: "预计开船日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_estimateSailAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.dest_address_code', { defaultValue: '目的地' }),
                    tag: 'Select',
                    key: 'CN_subLogisticsHeadList.addressCode',
                    options: this.addressCodeList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.ship_port', { defaultValue: "发运港" }),
                    tag: 'Select',
                    key: 'EQ_shipPortId',
                    options: this.getSystemPortList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' }),
                    tag: 'vDatepicker',
                    key: 'BT_expectPortArrivalDate',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.purpose_port', { defaultValue: "目的港" }),
                    tag: 'Select',
                    key: 'EQ_purposePortId',
                    options: this.getSystemPortList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.invoice_status', { defaultValue: "发票状态" }),
                    tag: 'Select',
                    key: 'EQ_invoiceStatus',
                    options: [
                        { value: 10, label: this.$t('fbb.headlogistics.invoice_10', { defaultValue: '发票未上传' }) },
                        { value: 20, label: this.$t('fbb.headlogistics.invoice_20', { defaultValue: '发票已上传' }) },
                        { value: 30, label: this.$t('fbb.headlogistics.invoice_30', { defaultValue: '发票已确认' }) }
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: "开船日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_actualSailAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.exception_status', { defaultValue: "异常状态" }),
                    tag: 'Select',
                    key: 'IN_exceptionStatus',
                    options: this.exceptionStatus,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: `${this.$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}/${this.$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}`,
                    tag: 'vInput',
                    key: 'EQ_logisticsNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.arrival_at', { defaultValue: "到港日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_arriveAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                // {
                //     label: "负责人",
                //     tag: 'vInput',
                //     key: 'EQ_designatedPerson',
                //     style: widthStyle
                // },
                {
                    label: this.$t('fbb.headlogistics.forwarder_warehouse', { defaultValue: "中转仓" }),
                    tag: 'Select',
                    key: 'EQ_forwarderWarehouseCode',
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.factory_batch_number', { defaultValue: "工厂批次号" }),
                    tag: 'vInput',
                    key: 'EQ_factoryBatchNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: "预计到仓日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_expectWarehouseArrivalDate',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.voyage_name', { defaultValue: "船名航次" }),
                    tag: 'vInput',
                    key: 'EQ_voyageName',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.container_number', { defaultValue: "集装箱号" }),
                    tag: 'vInput',
                    key: 'CN_containerNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.stock_in', { defaultValue: "妥投日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_stockinAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "Shipment id",
                    tag: 'vInput',
                    key: 'EQ_subLogisticsHeadList.shipmentId',
                    // default:this.initData,
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计交货日期' }),
                    tag: 'vDatepicker',
                    key: 'BT_expectStuffingDate',
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.customer_tax_no', { defaultValue: '税号' }),
                    tag: 'vInput',
                    key: 'EQ_taxNumber',
                    // default:this.initData,
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes,
                }, {
                    title: this.$t('fbb.inbound.client_organization', { defaultValue: '客户组织' }),
                    width: 80,
                    render: (h, { row }) => {
                    return <div>{this.findRenderLabel(this.contextList, row.organizationId)}</div>
                    }
                }, {
                    // title: '头程单号/来源单号/关联计划单号/异常',
                    title: `${this.$t('fbb.headlogistics.prelogistics_number', { defaultValue: '头程单号' })}/${this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' })}/${this.$t('fbb.headlogistics.sublogistics_number', { defaultValue: '关联计划单号' })}/${this.$t('fbb.headlogistics.exception', { defaultValue: '异常' })}`,
                    sortable: true,
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.preLogisticsNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.associatedNo || '--'}</div>
                            <div>{row.subLogisticsNos || '--'}</div>
                            <div>{this.getExceptionStatus(row.exceptionStatus)}</div>
                        </div>
                    }
                },
                {
                    title: `${this.$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' })}/${this.$t('global.common.line', { defaultValue: '项目' })}`,
                    // key: 'sourceChannel',
                    render: (h, { row }) => {
                        let logistics;
                        switch (row.logisticsType) {
                            case 'transfer': logistics = this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' }); break;
                            case 'through': logistics = this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直发' }); break;
                        }
                        let product = this.getAllProduct.filter(item => {
                            return item.value == row.lineId
                        })[0] || {}
                        return <div>
                            <div>{logistics}</div>
                            <div>{product.label || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.dest_address_code', { defaultValue: '目的地' }),
                    width: 90,
                    render: (h, { row }) => {
                        // let orgWarehouseCodesEle = row.orgWarehouseCodes.split(',').map(item => {
                        //     return <div>{item}</div>
                        // })
                        return <div>
                            <div>{row.addressCodes}</div>
                        </div>
                    }
                },
                {
                    // title: '单据状态/发票状态',
                    title: `${this.$t('fbb.headlogistics.order_status', { defaultValue: '单据状态' })}/${this.$t('fbb.headlogistics.invoice_status', { defaultValue: '发票状态' })}`,
                    width: 90,
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.getOrderStatus(row.orderStatus)}</div>
                            <div>{this.getTicketStatus(row.invoiceStatus)}</div>
                        </div>
                    }
                },
                // {
                //     title: '贷代类型/货代公司',
                //     width: 120,
                //     render: (h, { row }) => {
                //         let carrierTypeMap = {
                //             0:"商舟",
                //             1:"其他",
                //         }
                //         return <div>
                //             <div>{carrierTypeMap[row.carrierType] || '--'}</div>
                //             <div>{row.forwarderName || '--'}</div>
                //         </div>
                //     }
                // },
                {
                    // title: '发运方式/发运港/目的港',
                    title: `${this.$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })}/${this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' })}/${this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' })}`,
                    width: 100,
                    render: (h, { row }) => {
                        let shipname;
                        switch (row.transportType) {
                            case 0: shipname = this.$t('fbb.headlogistics.fcl_by_sea', { defaultValue: '海运整柜FCL' }); break;
                            case 1: shipname = this.$t('fbb.headlogistics.air_transport', { defaultValue: '空运' }); break;
                            case 6: shipname = this.$t('fbb.headlogistics.ltl_by_sea', { defaultValue: 'LTL海运拼箱' }); break;
                            case 7: shipname = this.$t('fbb.headlogistics.lcl_by_sea', { defaultValue: '自拼箱' }); break;
                            case 8: shipname = this.$t('fbb.headlogistics.express', { defaultValue: '快递' }); break;
                            case 9: shipname = this.$t('fbb.headlogistics.sea_transport', { defaultValue: '海运' }); break;
                            case 99: shipname = '--'; break;
                        }
                        return <div>
                            <div>{shipname || '--'}</div>
                            <div>{row.shipPort || '--'}</div>
                            <div>{row.purposePort || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计装柜日期' }),
                    width:(this.formData.search['daishenhe']===0||this.formData.search['daidingcang']===0) ? 110 : 0,
                    sortable: true,
                    key:'expectStuffingDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectStuffingDate) {
                            val = row.expectStuffingDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' }),
                    sortable:true,
                    width:(this.formData.search['yifachuan']===0) ? 110 : 0,
                    key:'actualLoadingDate ',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.actualLoadingDate) {
                            val = row.actualLoadingDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val  || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.estimate_sail_at', { defaultValue: '预计开船日期' }),
                    sortable:true,
                    width:(this.formData.search['daifachuan']===0) ? 110 : 0,
                    key:"estimateSailAt",
                    render: (h, { row }) => {
                        let val = ""
                        if (row.estimateSailAt) {
                            val = row.estimateSailAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: '实际开船日期' }),
                    sortable:true,
                    width:(this.formData.search['yifachuan']===0||this.formData.search['daiqingguan']===0) ? 110 : 0,
                    key:'actualSailAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.actualSailAt) {
                            val = row.actualSailAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val  || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' }),
                    width:(this.formData.search['yifachuan']===0||this.formData.search['daiqingguan']===0) ? 110 : 0,
                    sortable: true,
                    key:'expectPortArrivalDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectPortArrivalDate) {
                            val = row.expectPortArrivalDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.customer_clearance_date', { defaultValue: '清关日期' }),
                    width:(this.formData.search['daiyuyue']===0) ? 110 : 0,
                    sortable: true,
                    key:'customerClearanceDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.customerClearanceDate) {
                            val = row.customerClearanceDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.arrive_at', { defaultValue: '实际到港日期' }),
                    width:(this.formData.search['daiyuyue']===0||this.formData.search['jianyanzhong']===0) ? 110 : 0,
                    sortable: true,
                    key:'arriveAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.arriveAt) {
                            val = row.arriveAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.appointment_at', { defaultValue: '预约送仓时间' }),
                    sortable: true,
                    key:'appointmentAt',
                    width:(this.formData.search['daituotou']===0||this.formData.search['daituotou']===0) ? 120 : 0,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.appointmentAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: '预计到仓日期' }),
                    sortable: true,
                    key:'expectWarehouseArrivalDate',
                    width:(this.formData.search['daituotou']===0) ? 110 : 0,
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectWarehouseArrivalDate) {
                            val = row.expectWarehouseArrivalDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.stock_in', { defaultValue: '妥投日期' }),
                    sortable:true,
                    width:(this.formData.search['yidaituotou']===0 || this.formData.search['daiscfp']===0) ? 110 : 0,
                    key:'stockinAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.stockinAt) {
                            val = row.stockinAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    },
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                },
            ];
        },

    },

};
